import React, { lazy } from "react";
import { useLocation } from "react-router";
import { Redirect, Route } from "react-router-dom";

import useIdentity, { ADMIN } from "../../lib/use-identity";
import { ADMIN as ADMIN_PATH, linkTo as adminLinkTo } from "./routes-links";

const AdminLazy = lazy(() =>
  import(/* webpackChunkName: "admin" */ "./admin-routes.web")
);

const AdminProtectedRoutes = () => {
  const { hasRole, communityCode } = useIdentity();
  const { pathname } = useLocation();

  if (!hasRole(ADMIN)) {
    window.location.href =
      // eslint-disable-next-line prefer-template
      window.location.origin +
      "/app/login?redirect=" +
      encodeURIComponent(
        window.location.origin +
          window.location.pathname +
          window.location.search +
          window.location.hash
      );
    return null;
  }

  // Always forward to the sites list if on the admin site
  if (communityCode === "admin" && pathname.indexOf(ADMIN_PATH) === 0) {
    return <Redirect to={adminLinkTo.sites()} />;
  }

  return <AdminLazy />;
};

export default <Route path={ADMIN_PATH} component={AdminProtectedRoutes} />;
